import React, { useEffect, useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Logo from "../../assets/img/Daimler_Logo_Text.png";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Button } from "react-bootstrap";
import preloadimg from "../../assets/img/preloader1.gif";

import { FaBars } from "react-icons/fa";
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.min.css";
import ChatRoomNew from "../comments/Comments";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";

const NavHeader = ({ title, guid, reportId, pageName, onclickmenu }) => {
  const [userInfo, setUserInfo] = useState(null);
  const [username, setUsername] = useState("");
  const [Switching, setSwitching] = useState(false);
  const [isReport, setisReport] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [persona, setPersona] = useState([]);
  const [personaGroupId, setpersonaGroupId] = useState([]);
  const [CheckGroupId, setCheckGroupId] = useState([]);
  const [openDialog, setopenDialog] = useState(false);
  const [personaId, setpersonaId] = useState();
  const [personaName, setpersonaName] = useState("");
  const [PersonaLoading, setPersonaLoading] = useState(true);
  const [passtoken, setpasstoken] = useState(
    !localStorage.getItem("access-token-storage") ||
      localStorage.getItem("access-token-storage") === null
      ? null
      : JSON.parse(localStorage.getItem("access-token-storage"))["accessToken"]
  );
  const { instance, accounts } = useMsal();
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const menubar = () => {
    var sideBar = document.getElementById("mySidenav").style.width;
    if (sideBar === "") {
      document.getElementById("mySidenav").style.width = "300px";
      document.getElementById("main").style.marginLeft = "305px";
      $(".item_menuText").show();
      $(".sideNavMenu_grid").css("justify-content", "start");
      $(".sideNavMenu").css("overflow-y", "auto");
    } else if (sideBar === "80px") {
      document.getElementById("mySidenav").style.width = "300px";
      document.getElementById("main").style.marginLeft = "305px";
      $(".item_menuText").show();
      $(".sideNavMenu_grid").css("justify-content", "start");
      $(".sideNavMenu").css("overflow-y", "auto");
    } else {
      document.getElementById("mySidenav").style.width = "80px";
      document.getElementById("main").style.marginLeft = "85px";
      $(".item_menuText").hide();
      $(".sideNavMenu_grid").css("justify-content", "center");
      $(".sideNavMenu").css("overflow-y", "hidden");
    }
  };

  useEffect(() => {
    if (onclickmenu === true) {
      document.getElementById("main").style.marginLeft = "305px";
    }
  }, [onclickmenu]);

  const notifications = () => {
    const x = document.getElementById("NotificationsIdValues");
    if (x.style.display === "") {
      $("#NotificationsIdValues").toggle(0);
      $("#main").css("marginRight", "400px");
    } else if (x.style.display === "none") {
      $("#NotificationsIdValues").toggle();
      $("#main").css("marginRight", "400px");
    } else {
      $("#NotificationsIdValues").toggle();
      $("#main").css("marginRight", "6px");
    }
  };

  const checkPath = () => {
    const getURl = new URL(window.location.href);
    // const Idfetch = url.searchParams.get("admClientId");
    const pathValue = getURl.pathname;

    if (
      pathValue === "/" ||
      pathValue === "/userRegistration" ||
      pathValue === "/ManageUser" ||
      pathValue === "/Settings"
    ) {
      setisReport(true);
    } else {
      setisReport(false);
    }
  };

  useEffect(() => {
    checkPath();
  });

  const email = localStorage.getItem("myemail");
  const userNameLocal = localStorage.getItem("userName");
  const userGroup = localStorage.getItem("userGroup");
  const navigate = useNavigate();

  const switchPersona = () => {
    setSwitching(true);
    setopenDialog(false);

    if (CheckGroupId.includes(104)) updateRLtype();

    const data = {
      email: email,
      userGroupId: personaId,
    };
    const url = `${process.env.REACT_APP_SERVER_URL}/aipd/updateDefaultUserGroup`;
    const header = {
      headers: {
        "oidc-token": passtoken,
      },
    };
    axios
      .post(url, data, header)

      .then(function (response) {
        if (response.status === 200) {
          setSwitching(false);
          setpersonaId();
          setpersonaName("");
          navigate("/");
          window.location.reload();
        }
      })
      .catch(function (error) {});
  };

  const [selectedItem, setSelectedItem] = useState("");
  const [selectedDefultRl, setselectedDefultRl] = useState("");

  const [selectedItemRlList, SetselectedItemRlList] = useState();
  const [RLLoading, SetRLLoading] = useState(true);

  const handleCheckboxChange = (item) => {
    setSelectedItem(item);
  };

  //  if(!RLLoading)
  //  console.log(selectedItemRlList)
  //  console.log(selectedItem)
  //  console.log(typeof(personaGroupId))

  const updateRLtype = () => {
    const url = `${process.env.REACT_APP_SERVER_URL}/aipd/updateDefaultRlType`;
    const header = {
      headers: {
        "oidc-token": passtoken,
      },
    };

    const data = { rlType: selectedItem };

    axios
      .post(url, data, header)

      .then(function (response) {
        if (response.status === 200) {
          console.log(response);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  useEffect(() => {
    if (passtoken === null) {
      return;
    } else {
      let accessTokenObjKeyMain = "msal.token.keys.";
      let accessTokenObjKeyclientId = "";
      if (instance) {
        accessTokenObjKeyclientId =
          instance?.controller?.config?.auth?.clientId;
      }
      const accessTokenObj = JSON.parse(
        localStorage.getItem(accessTokenObjKeyMain + accessTokenObjKeyclientId)
      );
      let accessToken = "";
      let accessTokenStr = "";
      if (accessTokenObj) {
        accessToken = JSON.parse(
          localStorage.getItem(accessTokenObj?.idToken[0])
        );
        accessTokenStr = accessToken?.secret;
      }
      if (accessTokenStr === passtoken) {
        setpasstoken(passtoken);
      } else {
        localStorage.setItem("access-token-storage", accessToken);
      }
    }
  }, []);

  // console.log(passtoken)

  const baseUrl = `${process.env.REACT_APP_SERVER_URL}/aipd/getUserGroupListForUser `;

  useEffect(() => {
    const fetchGetPersona = async () => {
      await fetch(`${baseUrl}`, {
        headers: {
          "oidc-token": passtoken,
          Accept: "application/json",
        },
      })
        .then((response) => {
          if (response.ok) {
            response.json().then((json) => {
              setPersona(json);
              setPersonaLoading(false);
              const userGroupIds = json.map((item) => item.userGroupId);
              setCheckGroupId(userGroupIds);

              // console.log(json)
              // const userGroupIds = json.map(persona => persona.userGroupId);
              // setpersonaGroupId(userGroupIds)
            });
          }
        })
        .catch((err) => {
          setPersona([]);
          setPersonaLoading(false);
        });
    };
    fetchGetPersona();
  }, [baseUrl]);

  // console.log(CheckGroupId)

  const baseUrlData = `${process.env.REACT_APP_SERVER_URL}/aipd/getUserDetails `;

  useEffect(() => {
    const GetReportData = async () => {
      await fetch(`${baseUrlData}`, {
        headers: {
          "oidc-token": passtoken,
          Accept: "application/json",
        },
      })
        .then((response) => {
          if (response.ok) {
            response.json().then((json) => {
              // console.log("json.data")
              // console.log(json)

              const defaultData = json;
              const defaultRLData = defaultData?.defaultRlType;
              const defaultRLDataLsit = defaultData?.rlTypes;
              const defaultRLDataLsitId = defaultData?.defaultUserGroup;

              // console.log(defaultRLData)
              // console.log(defaultRLDataLsit)
              // console.log(defaultRLDataLsitId)

              setSelectedItem(defaultRLData);
              setselectedDefultRl(defaultRLData);
              SetselectedItemRlList(defaultRLDataLsit);
              setpersonaGroupId(defaultRLDataLsitId);
              SetRLLoading(false);
              localStorage.setItem("userGroup", defaultRLDataLsitId);
              localStorage.setItem("RLTYPE", defaultRLData);
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };
    GetReportData();
  }, [baseUrl]);

  const logout = async () => {
    // Will redirect to MSAL to end the session then redirect back to the configured `postLogoutRedirectUri`
    try {
      // Sign out the user
      // await instance.logoutRedirect({
      //   postLogoutRedirectUri: `${process.env.REACT_APP_SSO_LOGOUT_REDIRECT_URL}`, // Replace with your redirect URI
      // });
      localStorage.clear();
      window.location.href = `${process.env.REACT_APP_SSO_LOGOUT_REDIRECT_URL}`;
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  useEffect(() => {
    if (passtoken === undefined || passtoken === null) {
      logout();
    }
  }, [passtoken]);
  return (
    <>
      <Navbar
        style={{
          paddingLeft: "2rem",
          paddingRight: "2rem",
          justifyContent: "space-between",
          border: "1px solid #D9D9D9",
        }}
        className="nav_bar navFlexbox"
        expand="lg"
        variant="light"
        fixed="top"
      >
        <div className="nav-items logo-placement">
          <FaBars
            onClick={menubar}
            sx={{ fill: "#A70E13 !important" }}
            fontSize={24}
            cursor="pointer"
          />

          <Navbar.Brand
            style={{ background: "transparent !important" }}
            href="/"
          >
            <img
              src={Logo}
              className="d-inline-block align-top"
              alt="Bharat Benz"
              width={271}
              // height={28}
            />
          </Navbar.Brand>
        </div>
        <div className="tool-name">
          <h4>Vruddhi Analytical Tool</h4>
        </div>

        <div
          style={{ background: "transparent !important" }}
          className="nav-items"
        >
          {/* <Bookmark /> */}

          {/* {!isReport && (
            <Badge badgeContent={0} max={99} color="primary">
              <EditNoteIcon
                style={{
                  fontSize: "35px",
                  cursor: "pointer",
                  background: "transparent !important",
                  color:'#A70E13s'
                }}
                id="notificationIDclick"
                value={{ color: "white" }}
                onClick={notifications}
              />
            </Badge>
          )}

          <Notifications /> */}

          <Box
            sx={{ display: "flex", alignItems: "center", textAlign: "center" }}
          >
            <Tooltip title="Account settings">
              <IconButton
                onClick={handleClick}
                size="small"
                sx={{ ml: 2 }}
                aria-controls={open ? "account-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "24px",
                    position: "relative",
                    width: "auto",
                    height: "36px",
                    borderRadius: "26.5px",
                    border: "1px solid #000",
                    paddingLeft: "16px",
                  }}
                >
                  <div
                    style={{
                      color: "#2c2c2c",
                      fontSize: "16px",
                    }}
                    className="item_bar profileDetails"
                  >
                    <div> {userNameLocal}</div>
                    {/* <div> {userInfo?.email}</div> */}
                  </div>
                  <Avatar
                    sx={{
                      width: 36,
                      height: 36,
                      backgroundColor: "#A70E13",
                      color: "white",
                      fontWeight: "600",
                    }}
                  >
                    {userNameLocal.charAt(0)}
                  </Avatar>
                  {/* {open ? (
                    <FaAngleUp
                      style={{
                        color: "#0000a0",
                        position: "absolute",
                        right: "-3%",
                        boxShadow: "0px 0px 4px rgba(0,0,0,0.8)",
                        background: "#eee",
                        borderRadius: "100%",
                        fontSize: "14px",
                        cursor: "pointer",
                      }}
                    />
                  ) : (
                    <FaAngleDown
                      style={{
                        color: "#0000a0",
                        position: "absolute",
                        right: "-3%",
                        boxShadow: "0px 0px 4px rgba(0,0,0,0.8)",
                        background: "#eee",
                        borderRadius: "100%",
                        fontSize: "14px",
                        cursor: "pointer",
                      }}
                    />
                  )} */}
                </div>
              </IconButton>
            </Tooltip>
          </Box>

          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                minWidth: "400px",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 27,
                  height: 27,
                  ml: -0.5,
                  mr: 1,
                  paddingLeft: "0px",
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <div className="profileInfo">
              <div className="profileInfoname">
                <div>
                  {" "}
                  {PersonaLoading ? (
                    <span> Getting Your Persona, Please wait...</span>
                  ) : (
                    <>
                      <div>{userNameLocal}</div>
                      <div>{email}</div>
                      To view user manual <a className="link-pdf" target="_blank" href="/AIP User Manual.pdf">Click here</a>
                    </>
                  )}{" "}
                </div>
              </div>

              <div>
                {" "}
                {PersonaLoading ? (
                  <span></span>
                ) : (
                  <>
                    <div className="profileInfoType">
                      {localStorage.getItem("userType")}
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="profilePersona">
              {PersonaLoading ? (
                <>
                  <div className="profilePersona">
                    <Skeleton count={2} height={30} />
                  </div>
                </>
              ) : (
                <>
                  {persona.map((name, index) => {
                    return (
                      <div key={index}>
                        <MenuItem
                          className="profilePersona1"
                          // onClick={() => switchPersona(name.userGroupId)}
                          onClick={() => {
                            setopenDialog(!openDialog);
                            setpersonaId(name.userGroupId);
                            setpersonaName(name.groupName);
                          }}
                        >
                          <div className="x135icu2">
                            <div className="icon-avatar-container">
                              <svg
                                fill="#A70E13"
                                viewBox="0 0 20 20"
                                width="2.5em"
                                height="2.5em"
                                className="rotate-on-hover"
                              >
                                {name.userGroupId === parseInt(userGroup) && (
                                  <g
                                    fillRule="evenodd"
                                    transform="translate(-446 -398)"
                                  >
                                    <g fillRule="nonzero">
                                      <path
                                        d="M96.628 206.613A7.97 7.97 0 0 1 96 203.5a7.967 7.967 0 0 1 2.343-5.657A7.978 7.978 0 0 1 104 195.5a7.978 7.978 0 0 1 5.129 1.86.75.75 0 0 0 .962-1.15A9.479 9.479 0 0 0 104 194a9.478 9.478 0 0 0-6.717 2.783A9.467 9.467 0 0 0 94.5 203.5a9.47 9.47 0 0 0 .747 3.698.75.75 0 1 0 1.381-.585zm14.744-6.226A7.97 7.97 0 0 1 112 203.5a7.967 7.967 0 0 1-2.343 5.657A7.978 7.978 0 0 1 104 211.5a7.978 7.978 0 0 1-5.128-1.86.75.75 0 0 0-.962 1.152A9.479 9.479 0 0 0 104 213a9.478 9.478 0 0 0 6.717-2.783 9.467 9.467 0 0 0 2.783-6.717 9.47 9.47 0 0 0-.747-3.698.75.75 0 1 0-1.381.585z"
                                        transform="translate(352 204.5)"
                                      ></path>
                                      <path
                                        d="M109.5 197h-2.25a.75.75 0 1 0 0 1.5h3a.75.75 0 0 0 .75-.75v-3a.75.75 0 1 0-1.5 0V197zm-11 13h2.25a.75.75 0 1 0 0-1.5h-3a.75.75 0 0 0-.75.75v3a.75.75 0 1 0 1.5 0V210z"
                                        transform="translate(352 204.5)"
                                      ></path>
                                    </g>
                                  </g>
                                )}
                              </svg>

                              <Avatar
                                sx={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "8.9%",
                                  transform: "translate(-50%, -50%)",
                                  color: "white",
                                  fontWeight: "600",
                                  textAlign: "center",
                                  display: "grid",
                                  justifyContent: "center",
                                }}
                                className={
                                  name.userGroupId === parseInt(userGroup)
                                    ? ""
                                    : "avtarwidthinactive"
                                }
                              >
                                {name.groupName.charAt(0)}
                              </Avatar>
                            </div>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                              alignContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <span>{name.groupName}</span>

                            {/* {name.userGroupId === 104 && (
                              <span className="user_items_cls items_cls">
                                {selectedDefultRl}
                              </span>
                            )} */}
                          </div>
                        </MenuItem>

                        <Divider
                          sx={{ backgroundColor: "#eee", height: "2px" }}
                        />
                      </div>
                    );
                  })}
                </>
              )}
            </div>
          </Menu>
        </div>
      </Navbar>

      <div id="NotificationsIdValues" className="notificationsCss">
        <ChatRoomNew
          title={title}
          guid={guid}
          reportId={reportId}
          pageName={pageName}
        />
      </div>

      {/* <div id="NotesValues" className="notificationsCss">
        <Notifications />
      </div> */}

      <Dialog
        open={openDialog}
        onClose={() => setopenDialog(!openDialog)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          style={{ background: "#A70E13", color: "#fff", fontWeight: "500" }}
          id="alert-dialog-title"
        >
          {"Switching Persona!!"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{ marginTop: "16px", color: "#8A9295" }}
          >
            <>Do you wish to switch to {personaName}?</>
          </DialogContentText>

          {/* {personaId === 104 && (
            <>
              <DialogContentText id="alert-dialog-description">
                Switch to your RL Type
              </DialogContentText>

              <DialogContentText id="alert-dialog-description">
                <div style={{ fontWeight: "600", paddingTop: "10px" }}>
                  Please Select RL Type
                </div>
              </DialogContentText>

              <DialogContentText id="alert-dialog-description">
                {RLLoading && <>Please wait</>}

                {!RLLoading && (
                  <>
                    {selectedItemRlList.map((item) => (
                      <FormControlLabel
                        key={item}
                        control={
                          <Checkbox
                            checked={selectedItem === item}
                            onChange={() => handleCheckboxChange(item)}
                          />
                        }
                        label={item}
                      />
                    ))}
                  </>
                )}
              </DialogContentText>
            </>
          )} */}
        </DialogContent>
        <DialogActions>
          <Button
            className="submit_btn"
            style={{ width: "auto" }}
            onClick={switchPersona}
            autoFocus
            disabled={personaId !== 104 ? false : RLLoading}
          >
            Yes
          </Button>

          <Button
            className="cancel_btn"
            style={{ width: "auto" }}
            onClick={() => setopenDialog(false)}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>

      {Switching && (
        <div
          style={{ fontSize: "18px", fontWeight: "600" }}
          className="switchingClass"
        >
          <div
            style={{
              position: "fixed",
              background: "rgba(0,0,0,0.8)",
              width: "100%",
              height: "100%",
              top: "0",
              left: "0",
              right: "0",
              bottom: "0",
              display: "grid",
              justifyContent: "center",
              alignItems: "center",
              color: "white",
              zIndex: "99999",
              justifyItems: "center",
              alignContent: "center",
            }}
          >
            <img width={200} src={preloadimg} alt="Loading" />
            <span>Switching to {personaName}</span>
          </div>
        </div>
      )}
    </>
  );
};

export default NavHeader;
